export const GET_REVIEWS_REQUEST = "GET_REVIEWS_REQUEST";
export const GET_REVIEWS_SUCCESS = "GET_REVIEWS_SUCCESS";
export const GET_REVIEWS_FAILURE = "GET_REVIEWS_FAILURE";

export const ADD_REVIEW_REQUEST = "ADD_REVIEW_REQUEST";
export const ADD_REVIEW_SUCCESS = "ADD_REVIEW_SUCCESS";
export const ADD_REVIEW_FAILURE = "ADD_REVIEW_FAILURE";

export const UPDATE_REVIEW_REQUEST = "UPDATE_REVIEW_REQUEST";
export const UPDATE_REVIEW_SUCCESS = "UPDATE_REVIEW_SUCCESS";
export const UPDATE_REVIEW_FAILURE = "UPDATE_REVIEW_FAILURE";

export const DELETE_REVIEW_REQUEST = "DELETE_REVIEW_REQUEST";
export const DELETE_REVIEW_SUCCESS = "DELETE_REVIEW_SUCCESS";
export const DELETE_REVIEW_FAILURE = "DELETE_REVIEW_FAILURE";

export const GET_PARTNER_REVIEWS_REQUEST = "GET_PARTNER_REVIEWS_REQUEST";
export const GET_PARTNER_REVIEWS_SUCCESS = "GET_PARTNER_REVIEWS_SUCCESS";
export const GET_PARTNER_REVIEWS_FAILURE = "GET_PARTNER_REVIEWS_FAILURE";

export const ADD_PARTNER_REVIEW_REQUEST = "ADD_PARTNER_REVIEW_REQUEST";
export const ADD_PARTNER_REVIEW_SUCCESS = "ADD_PARTNER_REVIEW_SUCCESS";
export const ADD_PARTNER_REVIEW_FAILURE = "ADD_PARTNER_REVIEW_FAILURE";

export const UPDATE_PARTNER_REVIEW_REQUEST = "UPDATE_PARTNER_REVIEW_REQUEST";
export const UPDATE_PARTNER_REVIEW_SUCCESS = "UPDATE_PARTNER_REVIEW_SUCCESS";
export const UPDATE_PARTNER_REVIEW_FAILURE = "UPDATE_PARTNER_REVIEW_FAILURE";

export const DELETE_PARTNER_REVIEW_REQUEST = "DELETE_PARTNER_REVIEW_REQUEST";
export const DELETE_PARTNER_REVIEW_SUCCESS = "DELETE_PARTNER_REVIEW_SUCCESS";
export const DELETE_PARTNER_REVIEW_FAILURE = "DELETE_PARTNER_REVIEW_FAILURE";
